import React from 'react';
import { Box, Button, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { Link } from 'react-router-dom';

const exams = [
  {
    name: 'JAMB',
    summary: 'Practise your registered UTME subject combination.',
    details: 'Choose four subjects, including Use of English. The test flow checks your weekly attempt availability before subject selection.',
    startPath: '/mock-test/jamb',
    resultsPath: '/mock-test/jamb/check-result',
  },
  {
    name: 'WAEC',
    summary: 'Practise across your selected WAEC subjects.',
    details: 'Choose 7 to 9 subjects, including English Language and Mathematics. The test flow checks your weekly attempt availability before subject selection.',
    startPath: '/mock-test/waec',
    resultsPath: '/mock-test/waec/check-result',
  },
];

const MockTests: React.FC = () => (
  <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: { xs: 3, md: 5 } }}>
    <Container maxWidth="md">
      <Stack spacing={1} sx={{ mb: 3 }}>
        <Typography variant="overline" color="text.secondary">Exam preparation</Typography>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>Mock Tests</Typography>
        <Typography color="text.secondary">
          Choose an examination to start a timed practice session or check an existing result.
        </Typography>
      </Stack>
      <Grid container spacing={2.5}>
        {exams.map((exam) => (
          <Grid item xs={12} sm={6} key={exam.name}>
            <Paper elevation={0} sx={{ height: '100%', p: { xs: 2.5, md: 3 }, border: '1px solid', borderColor: 'divider', display: 'flex', flexDirection: 'column' }}>
              <FactCheckOutlinedIcon color="primary" aria-hidden="true" />
              <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mt: 1.5 }}>{exam.name}</Typography>
              <Typography variant="subtitle2" sx={{ mt: 0.5 }}>{exam.summary}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5, flexGrow: 1 }}>{exam.details}</Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mt: 3 }}>
                <Button component={Link} to={exam.startPath} variant="contained" endIcon={<ArrowForwardIcon />} sx={{ minHeight: 44 }}>
                  Start {exam.name} Mock
                </Button>
                <Button component={Link} to={exam.resultsPath} variant="outlined" sx={{ minHeight: 44 }}>
                  Check results
                </Button>
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default MockTests;